// src/screens/DataDeletionScreen/components/DataDeletionConfirm/style.ts
import styled from 'styled-components';
import { colors } from 'constants/colors';

export const DataDeletionConfirmContainer = styled.div`
  min-height: 596px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: ${colors.white};

  .content {
    max-width: 680px;
    padding: 80px 24px;
  }

  h1 {
    font-size: 40px;
    font-weight: 400;
    margin-bottom: 32px;
  }

  h2 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 24px;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 12px;
  }

  a {
    text-decoration: underline;
  }
  .hotelLogoBig {
    max-width: 240px;
    margin-bottom: 20px;
  }
`;